/*
* This is the interface for the TmsAsset class. It is used to define the structure of the TMS_ASSETS collection in Firestore.
*/

import { Timestamp } from 'firebase/firestore';
import { FirestoreDocument } from './FirestoreDocument';

export interface IOriginHub {
  Name: string;
  Id: string;
}

export interface ITransitLane {
  Name: string;
  Id: string;
}

export interface IClient {
  BusinessSubUnit: string;
  BusinessUnit: string;
}

interface ITmsAsset {
  Attributes: Record<string, any>;
  AverageDailySales: number | null;
  Category: string;
  Clients: IClient[];
  Cost: number | null;
  CountryOfOrigin: string;
  CreatedAt: Timestamp;
  Currency: string;
  CustomsTariffNumber: string;
  Description: string;
  OriginHub: IOriginHub;
  Height: number | null;
  Id: string | null;
  Images: string[];
  IsActive: boolean | null;
  LastCountDate: Timestamp;
  LastCycleCountDate: Timestamp;
  LeadTime: number | null;
  Length: number | null;
  Manufacturer: string;
  MaxStockLevel: number | null;
  MinStockLevel: number | null;
  Model: string;
  Name: string;
  Price: number | null;
  ProductCode: string;
  QualityCheckDate: Timestamp;
  QuantityAvailable: number | null;
  QuantityOnHand: number | null;
  QuantityReserved: number | null;
  ReorderPoint: number | null;
  ReorderQuantity: number | null;
  Seasonality: {
    PeakMonths: number[];
    PeakMultiplier: number | null;
  };
  Sku: string;
  Subcategory: string;
  Supplier: string;
  Tags: string[];
  Upc: string;
  UpdatedAt: Timestamp;
  Weight: number | null;
  Width: number | null;
  Warranty: string;
}

export class TmsAsset extends FirestoreDocument implements ITmsAsset {
    Attributes: Record<string, any> = {};
    AverageDailySales: number | null = null;
    Category = '';
    Clients: IClient[] = [];
    Cost: number | null = null;
    CountryOfOrigin = '';
    CreatedAt = Timestamp.now();
    Currency = '';
    CustomsTariffNumber = '';
    Description = '';
    OriginHub = { Name: '', Id: '' };
    Height;
    Id;
    Images: string[] = [];
    IsActive: boolean | null = null;
    LastCountDate = Timestamp.now();
    LastCycleCountDate = Timestamp.now();
    LeadTime: number | null = null;
    Length;
    Manufacturer = '';
    MaxStockLevel: number | null = null;
    MinStockLevel: number | null = null;
    Model = '';
    Name = '';
    Price: number | null = null;
    ProductCode = '';
    QualityCheckDate = Timestamp.now();
    QuantityAvailable: number | null = null;
    QuantityOnHand: number | null = null;
    QuantityReserved: number | null = null;
    ReorderPoint: number | null = null;
    ReorderQuantity: number | null = null;
    Seasonality = { PeakMonths: [], PeakMultiplier: null };
    Sku = '';
    Subcategory = '';
    Supplier = '';
    Tags: string[] = [];
    Upc = '';
    UpdatedAt = Timestamp.now();
    Weight: number | null = null;
    Width;
    Warranty = '';
  
    constructor(data?: Partial<ITmsAsset>) {
        super();
        if (data) {
          Object.keys(data).forEach(key => {
            if (key in this) {
              (this as any)[key] = (data as any)[key];
            }
          });
        }
    }

    protected get collectionName(): string {
        return 'TMS_ASSETS';
    }
  }